import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import Yup from '../../../../helpers/custom-yup'
import Modal from '../../../../components/modal/modal.component'
import { MuvicardService } from '../../../../services/muvicard.service'
import { BoxCancel, BoxModal } from './style.style'

const schema = Yup.object().shape({
	motivo: Yup.string().required(
		'Por favor digite o motivo do cancelamento do cartão'
	)
})

export class CancelButton extends Component {
	constructor(props) {
		super(props)

		this.state = {
			openModal: false,
			canUpdateStatus: false
		}
	}

	close = motivo => {
		MuvicardService.CardCancellation(motivo)
			.then(e => {
				if (e.data.success) {
					this.props.toastSuccess({
						message: 'Cartão cancelado com sucesso.'
					})
					this.setState({ canUpdateStatus: false })
				} else {
					this.props.toastError({
						message:
							'Houve um erro no cancelamento do seu cartão Muvicard.'
					})
				}
			})
			.catch()
		this.setState({ openModal: false })
	}

	getCardInfo = () => {
		const { toastError } = this.props

		MuvicardService.GetCardInfo().then(res => {
			if (res.success) {
				if (res.data.status === 'Cancelado') {
					this.setState({ canUpdateStatus: false })
				} else {
					this.setState({ canUpdateStatus: true })
				}
			} else {
				if (res.errors && res.errors.length > 0) {
					toastError({ message: res.errors })
				}
			}
		})
	}

	componentDidMount() {
		this.getCardInfo()
	}

	render() {
		return (
			<Formik
				validationSchema={schema}
				initialValues={{
					motivo: ''
				}}
				render={props => (
					<Form>
						<BoxCancel>
							{this.state.canUpdateStatus ? (
								<button
									type="button"
									onClick={() => this.setState({ openModal: true })}>
									Deseja cancelar o cartão Muvicard?
								</button>
							) : (
								<button type="button" disabled>
									Este cartão já está cancelado!
								</button>
							)}
						</BoxCancel>
						<Modal
							noPadding
							animation="fadeIn"
							isOpen={this.state.openModal}
							onClose={() => this.setState({ openModal: false })}>
							<BoxModal>
								<h3>Motivo do cancelamento</h3>

								<textarea
									autoComplete="off"
									name="motivo"
									id="motivo"
									onBlur={props.handleBlur}
									onChange={props.handleChange}
									value={props.values.motivo}
								/>

								<button
									disabled={!props.values.motivo}
									className=""
									onClick={() => {
										this.close(props.values.motivo)
										props.setFieldValue('motivo', '')
									}}>
									Enviar solicitação
								</button>
							</BoxModal>
						</Modal>
					</Form>
				)}
			/>
		)
	}
}
